import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        operable: filters.operable,
        date:     Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'CMDBBackupCake',
        endpoint:           endpoints.cmdb.backupCake,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            total:   response.with_backup + response.without_backup,
            results: [
                {
                    name: 'withBackup',
                    y:    response.with_backup
                },
                {
                    name: 'withoutBackup',
                    y:    response.without_backup
                }
            ]
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBBackupCake.js